<template>
  <div class="privacy-switcher">
    <span>Private Mode</span>
    <div class="radio-buttons">
      <label>
        <input
          type="radio"
          name="privacy"
          value="light"
          @change="setPrivacyMode('yes')"
          :checked="currentPrivacyMode === 'yes'"
        />
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="privacy"
          value="dark"
          @change="setPrivacyMode('no')"
          :checked="currentPrivacyMode === 'no'"
        />
        No
      </label>
    </div>
  </div>
</template>

<script setup lang="ts">
import { usePrivacyStore } from '@/stores'
import { storeToRefs } from 'pinia'

const privacyStore = usePrivacyStore()
const { currentPrivacyMode } = storeToRefs(privacyStore)

const setPrivacyMode = (mode: string) => {
  privacyStore.setPrivacyMode(mode)
}
</script>

<style scoped>
.privacy-switcher {
  display: flex;
  gap: 0.3125rem;
  font-size: var(--font-size-small);
  font-style: italic;
  justify-content: space-between;
  height: 100%;
  align-items: center;
}

.privacy-switcher .radio-buttons {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 1.25rem;
  width: 50%;
}

.privacy-switcher .radio-buttons label {
  cursor: pointer;
  color: var(--text-color);
  display: flex;
  align-items: center;
  gap: 0.15625rem;
  width: 3.125rem;
}
</style>
